import { useRoutes } from "react-router-dom";
import LandingPage from "../pages/landing";
import OrdersPage from "../pages/orders";
import OrderPage from "../pages/order";
import OrderDetailsPage from "../pages/orderDetails";
import StatusPage from "../pages/status";
import AuthorizePage from "../pages/authorize";
import LoginPage from "../pages/login";
import SignupPage from "../pages/signup";
import VerifyEmailPage from "../pages/verifyEmail";
import ForgotPasswordPage from "../pages/forgotPassword";
import VerifyResetCodePage from "../pages/verifyResetCode";
import ResetPasswordPage from "../pages/resetPassword";
import SettingsPage from "../pages/settings";
import ShippingLabelPage from "../pages/shippingLabel";
import ReviewPurchasePage from "../pages/reviewPurchase";
import { ShippingLabelProvider } from "../context/ShippingLabelContext";
import ProtectedRoute from "./ProtectedRoute";
import { routeEndpoints } from "./routeEndpoints";

export default function AppRoutes() {
  return useRoutes([
    {
      path: routeEndpoints.landing,
      element: <LandingPage />,
    },

    {
      element: <ProtectedRoute />,
      children: [
        {
          path: routeEndpoints.orders,
          element: <OrdersPage />,
        },

        {
          path: routeEndpoints.orderDetails,
          element: <OrderDetailsPage />,
        },

        {
          path: routeEndpoints.settings,
          element: <SettingsPage />,
        },

        {
          element: <ShippingLabelProvider />,
          children: [
            {
              path: routeEndpoints.shippingLabel,
              element: <ShippingLabelPage />,
            },

            {
              path: routeEndpoints.reviewPurchase,
              element: <ReviewPurchasePage />,
            },
          ],
        },
      ],
    },

    {
      path: routeEndpoints.order,
      element: <OrderPage />,
    },

    {
      path: routeEndpoints.shippingStatus,
      element: <StatusPage />,
    },

    {
      path: routeEndpoints.authorize,
      element: <AuthorizePage />,
    },

    {
      path: routeEndpoints.login,
      element: <LoginPage />,
    },

    {
      path: routeEndpoints.signup,
      element: <SignupPage />,
    },

    {
      path: routeEndpoints.verifyEmail,
      element: <VerifyEmailPage />,
    },

    {
      path: routeEndpoints.forgotPassword,
      element: <ForgotPasswordPage />,
    },

    {
      path: routeEndpoints.verifyResetCode,
      element: <VerifyResetCodePage />,
    },

    {
      path: routeEndpoints.resetPassword,
      element: <ResetPasswordPage />,
    },
  ]);
}
